module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-17.da2fce17.png";